export default "__VITE_PUBLIC_ASSET__9c288642__"